(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/hooks/assets/javascripts/use-get-win-amount.js') >= 0) return;  svs.modules.push('/components/pool-betting/hooks/assets/javascripts/use-get-win-amount.js');
"use strict";


const {
  useDrawResultFromCurrentWagerDraw
} = svs.components.tipsen.hooksWager;
const {
  useGetPlayerWagerQuery,
  useGetMarketplaceWagerdetailsQuery
} = svs.components.tipsen.store.tipsenApi;
const {
  format
} = svs.utils;
const getAddonDrawWinAmount = _ref => {
  var _addonBet$wins, _addonBet$wins2;
  let {
    addonBet,
    allDrawNumbers,
    drawNumber
  } = _ref;
  if (!drawNumber || !addonBet || !((_addonBet$wins = addonBet.wins) !== null && _addonBet$wins !== void 0 && _addonBet$wins.length) > 0 || !allDrawNumbers || !allDrawNumbers.size) {
    return 0;
  }
  let indexOfSelectedDraw = 0;
  for (const tempDrawNumber of allDrawNumbers) {
    if (tempDrawNumber === drawNumber) {
      break;
    }
    indexOfSelectedDraw++;
  }
  const relatedAddonDrawNumber = addonBet.addonCompletedDrawNumbers[indexOfSelectedDraw] || undefined;
  let addonWin = 0;
  addonBet === null || addonBet === void 0 || (_addonBet$wins2 = addonBet.wins) === null || _addonBet$wins2 === void 0 || _addonBet$wins2.forEach(win => {
    if (win.drawNumber === relatedAddonDrawNumber) {
      addonWin += parseInt(win.amount, 10);
    }
  });
  return addonWin;
};
const getWinAmountsForCurrentDraw = _ref2 => {
  let {
    drawNumber,
    productWins,
    addonBet,
    allDrawNumbers
  } = _ref2;
  let productWinAmountForDraw = 0;
  let addOnWinAmountForDraw = 0;
  productWins === null || productWins === void 0 || productWins.forEach(productWin => {
    if (productWin.drawNumber === drawNumber) {
      productWinAmountForDraw += parseInt(productWin.amount, 10);
    }
  });
  addOnWinAmountForDraw = getAddonDrawWinAmount({
    addonBet,
    allDrawNumbers,
    drawNumber
  });
  const totalWinForDraw = productWinAmountForDraw + addOnWinAmountForDraw;
  return [productWinAmountForDraw, addOnWinAmountForDraw, totalWinForDraw];
};
const getGroupWinAmounts = function (drawNumber) {
  let groupWinAmounts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const currentGroupWinAmounts = groupWinAmounts[drawNumber] || groupWinAmounts.total;
  const groupWinAmount = currentGroupWinAmounts !== null && currentGroupWinAmounts !== void 0 && currentGroupWinAmounts.group ? format.CurrencyFromJupiterString(currentGroupWinAmounts.group) : 0;
  const playerWinAmount = currentGroupWinAmounts !== null && currentGroupWinAmounts !== void 0 && currentGroupWinAmounts.share ? format.CurrencyFromJupiterString(currentGroupWinAmounts.share) : 0;
  const groupAddonWinamount = currentGroupWinAmounts !== null && currentGroupWinAmounts !== void 0 && currentGroupWinAmounts.sportkryssGroup ? format.CurrencyFromJupiterString(currentGroupWinAmounts.sportkryssGroup) : 0;
  const playerAddonWinamount = currentGroupWinAmounts !== null && currentGroupWinAmounts !== void 0 && currentGroupWinAmounts.sportkryssShare ? format.CurrencyFromJupiterString(currentGroupWinAmounts.sportkryssShare) : 0;
  const totalGroupWinAmount = format.CurrencyFromJupiterString(groupWinAmount + groupAddonWinamount);
  const totalPlayerWinAmount = format.CurrencyFromJupiterString(playerWinAmount + playerAddonWinamount);
  return {
    groupWinAmount,
    playerWinAmount,
    groupAddonWinamount,
    playerAddonWinamount,
    totalGroupWinAmount,
    totalPlayerWinAmount
  };
};

const calculateGroupWinAmounts = _ref3 => {
  let {
    winDivisions,
    winDivisionsRowCount,
    customerShareCount,
    totalShareCount,
    rowPriceMulti = 1
  } = _ref3;
  let groupWinAmount = 0;
  let playerWinAmount = 0;
  if (!Array.isArray(winDivisions) || !Array.isArray(winDivisionsRowCount)) {
    return {
      groupWinAmount,
      playerWinAmount
    };
  }
  for (const {
    winDiv,
    winValue
  } of winDivisions) {
    const winDivisionWinValue = (winDivisionsRowCount === null || winDivisionsRowCount === void 0 ? void 0 : winDivisionsRowCount[winDiv - 1]) * format.CurrencyFromJupiterString(winValue) * rowPriceMulti;
    const winDivisionShareValue = winDivisionWinValue / totalShareCount;
    playerWinAmount += winDivisionShareValue * customerShareCount;
    groupWinAmount += winDivisionShareValue * totalShareCount;
  }
  return {
    groupWinAmount: groupWinAmount.toFixed(2),
    playerWinAmount: playerWinAmount.toFixed(2)
  };
};
const calculatePlayerWinAmount = _ref4 => {
  let {
    winDivisions,
    winDivisionsRowCount,
    rowPriceMulti = 1
  } = _ref4;
  let playerWinAmount = 0;
  if (!Array.isArray(winDivisions) || !Array.isArray(winDivisionsRowCount)) {
    return playerWinAmount;
  }
  for (const {
    winDiv,
    winValue
  } of winDivisions) {
    playerWinAmount += (winDivisionsRowCount === null || winDivisionsRowCount === void 0 ? void 0 : winDivisionsRowCount[winDiv - 1]) * format.CurrencyFromJupiterString(winValue) * rowPriceMulti;
  }
  return playerWinAmount;
};
const useGetWinAmount = _ref5 => {
  let {
    wagerId,
    winDivisionsRowCount,
    activeDrawNumber,
    allDrawNumbers,
    hasMaskedOutcomes = false
  } = _ref5;
  const {
    data: wagerData
  } = useGetPlayerWagerQuery({
    wagerId
  }, {
    skip: !wagerId
  });
  const {
    addonBet = {},
    productBet = {}
  } = wagerData !== null && wagerData !== void 0 ? wagerData : {};
  const {
    completedDrawNumbers = [],
    drawNumber,
    gameBoard,
    isGroup,
    properties = {},
    wins: productWins
  } = productBet;
  const currentDrawNumber = activeDrawNumber || drawNumber;
  const {
    rowPriceMulti = 1
  } = gameBoard || {};
  const {
    customerShareCount,
    totalShareCount,
    groupId,
    groupWinAmounts = {}
  } = properties;
  const isDrawCompleted = completedDrawNumbers.includes(currentDrawNumber) && !hasMaskedOutcomes;

  const {
    data: marketPlaceData
  } = useGetMarketplaceWagerdetailsQuery({
    groupId,
    wagerId
  }, {
    skip: !isGroup
  });

  const [{
    data: drawResultData
  }] = useDrawResultFromCurrentWagerDraw({
    wagerId
  });
  const [, winDivisions] = drawResultData;
  let groupData;
  let winAmount = 0;
  let addonWinAmount = 0;
  let productWinAmount = 0;
  const isDrawCompleteAndUnmasked = isDrawCompleted && !hasMaskedOutcomes;
  if (isGroup) {
    var _ref6, _groupData$totalPlaye, _groupData, _groupData2;
    groupData = isDrawCompleteAndUnmasked ?
    getGroupWinAmounts(currentDrawNumber, groupWinAmounts) :
    calculateGroupWinAmounts({
      winDivisions,
      winDivisionsRowCount,
      customerShareCount,
      totalShareCount,
      rowPriceMulti
    });
    winAmount = (_ref6 = (_groupData$totalPlaye = (_groupData = groupData) === null || _groupData === void 0 ? void 0 : _groupData.totalPlayerWinAmount) !== null && _groupData$totalPlaye !== void 0 ? _groupData$totalPlaye : (_groupData2 = groupData) === null || _groupData2 === void 0 ? void 0 : _groupData2.playerWinAmount) !== null && _ref6 !== void 0 ? _ref6 : 0;
    groupData.groupName = marketPlaceData === null || marketPlaceData === void 0 ? void 0 : marketPlaceData.groupName;
  } else if (isDrawCompleteAndUnmasked) {
    const [productWinAmountForDraw, addOnWinAmountForDraw, totalWinForDraw] = getWinAmountsForCurrentDraw({
      drawNumber: currentDrawNumber,
      productWins,
      addonBet,
      allDrawNumbers
    });
    winAmount = totalWinForDraw;
    addonWinAmount = addOnWinAmountForDraw;
    productWinAmount = productWinAmountForDraw;
  } else {
    winAmount = calculatePlayerWinAmount({
      winDivisions,
      winDivisionsRowCount,
      rowPriceMulti
    });
  }
  return {
    isDrawCompleted,
    currentDrawNumber,
    winAmount: format.CurrencyFromJupiterString(winAmount),
    groupData: groupData && Object.keys(groupData).length > 0 ? groupData : undefined,
    addonWinAmount,
    productWinAmount
  };
};
setGlobal('svs.components.poolBetting.hooks', {
  useGetWinAmount
});

 })(window);